/**
 * Resolve SPA API paths against optional absolute Railway origin.
 *
 * Empty `VITE_API_ORIGIN` → relative `/api/...` (Vite local proxy only).
 * Set to `https://api.footballsubs.com` (or `https://dev.api...`) for
 * direct browser → Railway calls.
 *
 * @param {string} path
 * @returns {string}
 */
export function apiUrl(path) {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;

  const origin = (import.meta.env.VITE_API_ORIGIN || "").replace(/\/$/, "");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return origin ? `${origin}${normalized}` : normalized;
}

/**
 * Cross-origin Railway calls use Bearer tokens, not cookies.
 * @param {RequestInit} [options]
 * @returns {RequestInit}
 */
export function apiFetchInit(options = {}) {
  const origin = (import.meta.env.VITE_API_ORIGIN || "").replace(/\/$/, "");
  if (!origin) return options;
  return { credentials: "omit", ...options };
}
